import styled from 'styled-components/macro';
import { fonts, mediaQuery, colours } from '@noths/styles-config';
import { fixedWidthContent } from '../../styles';

export const Container = styled.div`
  display: none;
  ${mediaQuery('tablet desktop')} {
    display: block;
    ${fixedWidthContent}
    font-size: ${fonts.size.xs};
    margin-top: 8px;
    margin-bottom: 8px;
  }
`;

// TODO: Extract to @noths/styles-config
colours.ceruleanLink = '#0CA6D4';

export const ContainerLink = styled.a`
  text-decoration: none;
  color: ${colours.ceruleanLink};
  position: relative;
  margin-right: 5px;
  &:after {
    content: ' > ';
    display: inline-block;
    position: relative;
    top: 0;
    margin-left: 5px;
    color: initial;
    cursor: initial;
  }
`;
